/**
 * Component to store all the intervals created in any page.
 * It should be used in order to allow our framework to clear all the intervals and timeouts
 * when change to another page.
 * This will avoid anoying callbacks from another scopes.
 *
 * @module app/components/IntervalManager.js
 */
import jQuery from 'jquery';

/**
 * Object containing all the interval and timeouts
 * id : clearMethod
 *
 * @type    {Object}
 */
var intervalStack = {};

/**
 * api var for methods included in this module's return statement
 *
 * @type {object}
 */
var api = {

    /**
     * This function will help us clearing everything in case we want to go to another page
     * in example.
     *
     * @params  {Array} filterOut   array of intervals to skip
     *
     * @returns {void}
     *
     * @public
     */
    clearAll: function (filterOut) {

        jQuery.each(intervalStack, function (id, clearMethod) {

            var undefinedFilterOut = function (filterOut) {

                if (typeof filterOut === 'undefined') {
                    window[clearMethod](id);
                }
            };

            if (filterOut instanceof Array && filterOut.indexOf(id) === -1) {
                window[clearMethod](id);
            } else {
                undefinedFilterOut(filterOut);
            }
        });

        intervalStack = {};
    },

    /**
     * Adds a new interval to the stack
     *
     * @params  {Integer} interval  to add to the list
     *
     * @returns {Integer}
     *
     * @public
     */
    pushInterval: function (interval) {

        intervalStack[interval] = 'clearInterval';
        return interval;
    },

    /**
     * Adds a new timeout to the stack
     *
     * @params  {Integer} interval  id representing the timeout
     *
     * @returns {Integer}
     *
     * @public
     */
    pushTimeout: function (interval) {

        intervalStack[interval] = 'clearTimeout';
        return interval;
    },
};

export default api;
